// extracted by mini-css-extract-plugin
export var dropdown = "_rk-0";
export var imageWrapper = "_rk-3";
export var itemNameContainer = "_rk-1";
export var productImage = "_rk-2";
export var spinnerWrapper = "_rk-4";